<template>
    <div class="w-e-text-container">
        <div ref="content" v-html="value"></div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            
        }
    },
    mounted() {
        this.$refs.content.innerHTML=this.value
    },
}
</script>
<style lang="scss" scoped>

/* table 样式 */
::v-deep table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
::v-deep table td,
::v-deep table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
::v-deep table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
::v-deep blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
::v-deep code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
::v-deep pre code {
  display: block;
}

/* ul ol 样式 */
::v-deep ul, ol {
  margin: 10px 0 10px 20px;
}
</style>